export function header_is_visible(state = true, action) {
    switch (action.type) {
        case 'CHANGE_HEADER_VIEW':
            return action.bool;
        default:
            return state;
    }
}

export function home_filter_value(state = '', action) {
    switch (action.type) {
        case 'UPDATE_FILTER':
            return action.text;
        default:
            return state;
    }
}

export function navigation_menu_show(state = false, action) {
    switch (action.type) {
        case 'TOGGLE_NAVUGATION_MENU':
            return action.bool;
        default:
            return state;
    }
}